import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getInstagramPostsApi, receiveInstagramWebhookApi, verifyInstagramWebhookApi } from "../../api/ecommerce/InstagramApi";

const initialState = {
  posts: null,
  listing: false,
  verification: null,
  verifying: false,
  webhookResponse: null,
  receiving: false,
  error: null,
};
const errorPayload = (err) => ({
  errorMessage: err?.response?.data?.message || err?.response?.data?.error || err?.message || "Something went wrong",
});

export const getInstagramPosts = createAsyncThunk(
  "instagram/getInstagramPosts",
  async (payload, { rejectWithValue }) => {
    try { return (await getInstagramPostsApi(payload))?.data; }
    catch (err) { return rejectWithValue(errorPayload(err)); }
  }
);

// Dispatch with { tenant, mode, verifyToken, challenge }.
export const verifyInstagramWebhook = createAsyncThunk(
  "instagram/verifyInstagramWebhook",
  async ({ tenant, ...params }, { rejectWithValue }) => {
    try { return (await verifyInstagramWebhookApi(tenant, params))?.data; }
    catch (err) { return rejectWithValue(errorPayload(err)); }
  }
);

// Dispatch with { tenant, body: originalSerializedJson, signature? }.
export const receiveInstagramWebhook = createAsyncThunk(
  "instagram/receiveInstagramWebhook",
  async ({ tenant, body, signature }, { rejectWithValue }) => {
    try { return (await receiveInstagramWebhookApi(tenant, body, signature))?.data; }
    catch (err) { return rejectWithValue(errorPayload(err)); }
  }
);

const instagramSlice = createSlice({
  name: "instagram",
  initialState,
  reducers: {
    clearInstagramError: (state) => { state.error = null; },
    clearInstagramState: () => initialState,
  },
  extraReducers: (builder) => {
    [
      [getInstagramPosts, "posts", "listing"],
      [verifyInstagramWebhook, "verification", "verifying"],
      [receiveInstagramWebhook, "webhookResponse", "receiving"],
    ].forEach(([thunk, key, flag]) => {
      builder
        .addCase(thunk.pending, (state) => { state[flag] = true; state.error = null; })
        .addCase(thunk.fulfilled, (state, action) => { state[flag] = false; state[key] = action.payload?.response ?? action.payload; })
        .addCase(thunk.rejected, (state, action) => { state[flag] = false; state.error = action.payload?.errorMessage || action.error?.message || "Something went wrong"; });
    });
  },
});

export const { clearInstagramError, clearInstagramState } = instagramSlice.actions;
export default instagramSlice.reducer;
